var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('router-view')],1),_c('Notification'),(_vm.componentExists(_vm.footer))?_c(_vm.footer,{tag:"v-component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }